import React, { useEffect, useState } from 'react';
import '../../css/sidebar.css'
import { authSidebarData, sidebarData } from './SidebarData';
import { useLocation, useNavigate } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItemText, ListItemButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { useSelector } from 'react-redux';

export default function Sidebar() {
	const [name, setName] = useState(JSON.parse(sessionStorage.getItem("menu")));
	const [alertOpen, setAlertOpen] = useState(false);
	const navigate = useNavigate();
	const [currentPath, setCurrentPath] = useState("");
	let location = useLocation();
	const authData = useSelector(state => state.auth);

	useEffect(() => {
		if(currentPath === location.pathname) {
			sessionStorage.setItem("menu", JSON.stringify(name));
			// window.location.reload();
		}

		if(location.pathname === "/") {
			setName({})
		}
		
		setCurrentPath(location.pathname);
		sessionStorage.setItem("menu", JSON.stringify(name));
	}, [location]);

	const openMenu = (menu) => {
		setName({ [menu] : !name[menu] })
	}

	const handleClick = (menu, url) => {
		setName({ [menu] : true })
		navigate(url);
	}

	const authAlert = (e) => {
		e.preventDefault();
		setName({});
		setAlertOpen(true);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
	}

  	return (
      <div className="sidebar">
        {(authData.user?.email === "twjung@finedigital.com")
          ? authSidebarData && authSidebarData.map((data) => {
              return (
                <List
                  key={data.id}
                  component="nav"
                  sx={{
                    padding: "3px 0px",
                    width: "100%",
                    backgroundColor: "rgb(45, 55, 72)",
                    color: "rgb(255, 255, 255)",
                  }}
                >
                  {data.subitems !== null ? (
                    <>
                      <ListItemButton
                        key={data.id}
                        // selected={selectedIndex === data.id}
                        onClick={() => {
                          openMenu(data.name);
                        }}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                          primary={data.name}
                        />
                        {name[data.name] ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse
                        in={name[data.name]}
                        timeout="auto"
                        unmountOnExit
                        component="li"
                      >
                        <List
                          sx={{
                            padding: "0px",
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "rgb(45, 55, 72)",
                          }}
                        >
                          {data.subitems &&
                            data.subitems.map((sitem) => {
                              return (
                                <div key={sitem.id}>
                                  {!authData.user.role.includes(sitem.auth) ? (
                                    <div
                                      onClick={(e) => {
                                        authAlert(e);
                                      }}
                                    >
                                      <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemText
                                          primary={sitem.name}
                                          primaryTypographyProps={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </ListItemButton>
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => {
                                        handleClick(data.name, sitem.url);
                                      }}
                                    >
                                      <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemText
                                          primary={sitem.name}
                                          primaryTypographyProps={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </ListItemButton>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </List>
                      </Collapse>
                    </>
                  ) : (
                    <div key={data.id}>
                      {!authData.user.role.includes(data.auth) &&
                      data.auth !== "dashboard" ? (
                        <ListItemButton
                          onClick={(e) => {
                            authAlert(e);
                          }}
                        >
                          <ListItemText
                            primary={data.name}
                            primaryTypographyProps={{
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          />
                        </ListItemButton>
                      ) : (
                        <ListItemButton
                          onClick={() => {
                            setName({});
                            navigate(data.url);
                          }}
                        >
                          <ListItemText
                            primary={data.name}
                            primaryTypographyProps={{
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          />
                        </ListItemButton>
                      )}
                    </div>
                  )}
                </List>
              );
            }) : sidebarData &&sidebarData.map((data) => {
              return (
                <List
                  key={data.id}
                  component="nav"
                  sx={{
                    padding: "3px 0px",
                    width: "100%",
                    backgroundColor: "rgb(45, 55, 72)",
                    color: "rgb(255, 255, 255)",
                  }}
                >
                  {data.subitems !== null ? (
                    <>
                      <ListItemButton
                        key={data.id}
                        // selected={selectedIndex === data.id}
                        onClick={() => {
                          openMenu(data.name);
                        }}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                          primary={data.name}
                        />
                        {name[data.name] ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse
                        in={name[data.name]}
                        timeout="auto"
                        unmountOnExit
                        component="li"
                      >
                        <List
                          sx={{
                            padding: "0px",
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "rgb(45, 55, 72)",
                          }}
                        >
                          {data.subitems &&
                            data.subitems.map((sitem) => {
                              return (
                                <div key={sitem.id}>
                                  {!authData.user.role.includes(sitem.auth) ? (
                                    <div
                                      onClick={(e) => {
                                        authAlert(e);
                                      }}
                                    >
                                      <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemText
                                          primary={sitem.name}
                                          primaryTypographyProps={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </ListItemButton>
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => {
                                        handleClick(data.name, sitem.url);
                                      }}
                                    >
                                      <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemText
                                          primary={sitem.name}
                                          primaryTypographyProps={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </ListItemButton>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </List>
                      </Collapse>
                    </>
                  ) : (
                    <div key={data.id}>
                      {!authData.user.role.includes(data.auth) &&
                      data.auth !== "dashboard" ? (
                        <ListItemButton
                          onClick={(e) => {
                            authAlert(e);
                          }}
                        >
                          <ListItemText
                            primary={data.name}
                            primaryTypographyProps={{
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          />
                        </ListItemButton>
                      ) : (
                        <ListItemButton
                          onClick={() => {
                            setName({});
                            navigate(data.url);
                          }}
                        >
                          <ListItemText
                            primary={data.name}
                            primaryTypographyProps={{
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          />
                        </ListItemButton>
                      )}
                    </div>
                  )}
                </List>
              );
            })}
        <Dialog
          open={alertOpen}
          onClose={alertCloseHandle}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ width: "350px", fontWeight: 600 }}
          >
            <ErrorOutlineRoundedIcon sx={{ pr: 1, verticalAlign: "-4px" }} />
            권한 경고
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ fontWeight: 600, m: "15px 0px 0px 10px" }}>
              해당 메뉴에 대한 권한이 없습니다!
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: "8px 20px 10px 8px" }}>
            <Button onClick={alertCloseHandle} variant="outlined">
              확인
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
}
